//@flow

import {
  openConversationApi,
  updateConversationsApi,
  updateConversationApi,
} from '../api/conversation';
import {endpoints as ConversationEndpoint} from '../api/conversation';

import type {
  OpenConversationRequest,
  UpdateConversationsRequest,
  UpdateConversationRequest,
} from '../../../../entities';
import {buildRoute} from '../../../../http';
import {conversationAdapter} from '../utils/conversation-adapter';

export function openConversationService(request: OpenConversationRequest) {
  return openConversationApi(request).toPromise();
}

export function updateConversationsService(
  request: UpdateConversationsRequest
) {
  return updateConversationsApi(request).toPromise();
}

export function updateConversationChatbotService(
  conversationId: string,
  disabled: boolean
): Promise<void> {
  const route = buildRoute(ConversationEndpoint.UPDATE_CONVERSATION, [
    conversationId,
  ]);

  return updateConversationApi(
    {
      disabledChatbot: disabled,
    },
    {route}
  )
    .toPromise()
    .then(conversation => {
      return conversationAdapter(conversation);
    });
}

export function updateConversationService(
  conversationId: string,
  request: UpdateConversationRequest
): Promise<void> {
  const route = buildRoute(ConversationEndpoint.UPDATE_CONVERSATION, [
    conversationId,
  ]);

  return updateConversationApi(request, {route}).toPromise();
}
